/** Synchronous fence: callbacks captured before exit cannot act for the next passenger. */
let generation = 0;

export function passengerSession(): number {
  return generation;
}

export function isPassengerSession(session: number): boolean {
  return session === generation;
}

export function endPassengerSession(clearPayment = false): void {
  generation++;
  // Unrelated ticket/refund screens retain legacy recovery references. Managed worker
  // references are passenger data; durable evidence lives in API/SQLite, never here.
  let managed = false;
  try {
    const pending = JSON.parse(sessionStorage.getItem('kiosk.edc.pending') ?? 'null') as {
      workerRequestId?: string;
    } | null;
    managed = typeof pending?.workerRequestId === 'string';
  } catch {
    /* A malformed legacy reference is not proof of no payment. */
  }
  if (clearPayment || managed) sessionStorage.removeItem('kiosk.edc.pending');
  sessionStorage.removeItem('kiosk.edc.retry');
}
